import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { httpRequest, queryClient } from '@hc/utils';
import toast from 'react-hot-toast';
import create from 'zustand';

export const useActivityDayMaster = create((set) => ({
  activityDayData: [],
  getActivityDayData: async () => {
    try {
      set({ loading: true });
      const { data } = await queryClient.fetchQuery({
        queryKey: ['master-mbf-day'],
        queryFn: async () => {
          const { data } = await httpRequest(
            'get',
            `${envConfig.api_url}/master/get-mbf-day`,
            {},
            true
          );
          return data;
        },
        staleTime: Infinity,
      });

      if (Array.isArray(data) && data?.length > 0) {
        const unitDataCopy = data.map((val) => {
          return {
            value: val?.id ?? '',
            label: val?.day ?? '',
            description: val?.description ?? '',
          };
        });
        set({
          loading: false,
          activityDayData: unitDataCopy,
        });
      }
      set({ loading: false });
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.response?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
}));
